export const savedFiltersKey = 'savedFilters';
export const currentFilterViewKey = 'currentFilterView';

export type FilterValue = string | boolean | string[] | [Date, Date] | [null, null] | null | Date[];

export type SavedFiltersFilterItem = {
    label: string;
    value: FilterValue;
    type: string;
}

export type SavedFilterItemView = {
    createdAt: string;
    id: string;
    name: string;
    filters: Record<string, SavedFiltersFilterItem>
}

export type SavedFilterType = {
    pageTitle: string;
    filterViews: Record<string, SavedFilterItemView>;
}

export type SavedFilters = Record<string, SavedFilterType>;

// export type FilterViewType = {
//     id: string;
//     name: string;
// }